import styles from 'styles/display/Badge.module.css'

const Badge = ({ count, ...rest }) =>
    count > 0
        ? <span className={styles.badge} {...rest}>{count}</span>
        : null

export default Badge